export default {
    getCompanySettings: (state) => state?.company?.settings,
    showDeliveryMethods: (state) => state?.company?.settings?.show_delivery_methods ?? true,
    hidePriceNotLoggedUser: (state) => state?.company?.settings?.hide_price_not_logged_user ?? false,
    blockAccessWhenUserNotLoggedIn: (state) => state?.company?.settings?.block_access_when_user_not_logged_in ?? false,
    showSellerFieldAtCheckout: (state) => state?.company?.settings?.show_seller_field_at_checkout ?? false,
    affiliateLinkEnabled: (state) => state?.company?.settings?.affiliate_link_enabled ?? false,
    getShowPaymentMethods: (state) => state?.company?.settings?.show_payment_methods ?? true,
    showDiscountCoupon: (state) => state?.company?.settings?.active_discount_coupon ?? true,
    getShowShippingCalculation: (state) => state?.company?.settings?.show_shipping_calculation ?? true,
    showRatings: (state) => state?.company?.settings?.show_ratings ?? true,
    getShowUnitOfMeasureInProductPrice: (state) => state?.companySettings?.show_unit_of_measure_in_product_price ?? false,
    showCodeOriginalBesideDescription: (state) => state?.company?.products_settings?.show_code_original_beside_description ?? false,
    showIpi: (state) => state?.company?.products_settings?.show_ipi ?? false,
    workWithOrder: (state) => state?.company?.settings?.work_with_order ?? false,

    login_fields: (state) => state?.company?.settings?.login_fields ?? [{ label: 'Email', value: 'email' }],

    use_location_popup: (state) => state?.company?.settings?.use_location_popup ?? false,

}
